import { makeRootStyles } from "../../theme/styles";

const useStyles = makeRootStyles(
  {
    textarea: {
      width: "100%",
      minHeight: "200px",
      display: "flex",
    },
    commentWrapper: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
  },
  { name: "ReturnReasonsComments" },
);

export { useStyles };
